export default function linkResolver(doc) {
    // Route for blog posts
    if (doc.type === "article") {
        return "/blog/" + doc.uid;
    }

    if (doc.type === "category") {
        return "/kategoria/" + doc.uid;
    }

    // Homepage route fallback
    return "/";
}
